/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_No_Attempt_BodyInputs */

const en_player_no_attempt_body = /** @type {(inputs: Player_No_Attempt_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start a new attempt to work through this course.`)
};

const ja_player_no_attempt_body = /** @type {(inputs: Player_No_Attempt_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このコースを受講するには、新しい受験を開始してください。`)
};

const fr_player_no_attempt_body = /** @type {(inputs: Player_No_Attempt_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Démarrez une nouvelle tentative pour suivre ce cours.`)
};

const de_player_no_attempt_body = /** @type {(inputs: Player_No_Attempt_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starten Sie einen neuen Versuch, um diesen Kurs zu bearbeiten.`)
};

/**
* | output |
* | --- |
* | "Start a new attempt to work through this course." |
*
* @param {Player_No_Attempt_BodyInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const player_no_attempt_body = /** @type {((inputs?: Player_No_Attempt_BodyInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_No_Attempt_BodyInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_player_no_attempt_body(inputs)
	if (locale === "ja") return ja_player_no_attempt_body(inputs)
	if (locale === "fr") return fr_player_no_attempt_body(inputs)
	return de_player_no_attempt_body(inputs)
});